<template>
	<text-element
		v-model="email"
		id-key="email"
		type="email"
		required
		autocomplete="email"
		placeholder="Email"
		:errors="errors || null"
		@keyup.enter="enterHandler"
	>
		<label
			v-if="showLabel"
			for="email"
			class="won-label-text-color mb-2 block text-sm font-medium"
		>
			Email
		</label>
	</text-element>
</template>

<script setup>
import TextElement from '../../forms/elements/text.vue';

const emit = defineEmits(['keyup:enter']);
defineProps({
	errors: {
		type: String,
		default: null
	},
	showLabel: {
		type: Boolean,
		default: true
	}
});

const email = defineModel();

const enterHandler = (event) => {
	emit('keyup:enter', event);
};
</script>
